import React, { useState } from 'react';
import { FileUpload } from '../../../../../../components/Form/FileUpload/FileUpload';
import { t } from '../../../../../../locales/translate';
import { readBytesUrl } from '../../../../../../util/util';
import { handleError } from '../../../../../../model/notification';
import { addLogo } from '../../../../../../model/logo';
import { TagsInput } from '../../../../../../components/Form/TagsInput/TagsInput';
import { Form, useChanges } from '../../../../../../components/Form/Form';
import { ModalController } from '../../../../../../components/Modal/ControlledModal';

interface Props {
  controller: ModalController<{ tags?: string[] }>;
}

export function UploadLogo({ controller }: Props): JSX.Element {
  const [, , model, trackChanges] = useChanges<{ tags?: string[] }>(controller.model);
  const [image, setImage] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | undefined>(undefined);

  function handleImageChange(file: File[]): void {
    if (file.length <= 0) {
      setImage(null);
      return setImagePreview(undefined);
    }
    const reader = new FileReader();

    reader.readAsDataURL(file[0]);

    reader.onload = () => {
      if (reader.result && typeof reader.result === 'string') {
        setImage(file[0]);
        setImagePreview(reader.result);
      }
    };
  }

  async function handleOnSubmit(): Promise<void> {
    try {
      if (image) {
        const bytes = await readBytesUrl(image);
        await addLogo(bytes, model.tags || []);
        controller.close();
      }
    } catch (error) {
      handleError(error);
    }
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid,
        });
        return (
          <>
            <FileUpload
              image={imagePreview}
              onChange={handleImageChange}
              label={t.actions.upload(t.model.logo._name)}
            />
            <TagsInput label={t.model.ticket.logoTags} name="tags" />
          </>
        );
      }}
    </Form>
  );
}
